 <div class="maintenance-wrapper" >
    <div class="maintenance-content">
        <img src="../../assets/img/logoev.png" class="logo" />
      <h1>Sorry for the inconvenience!</h1>
      <p>
        The application is currently undergoing maintenance.
        We'll be back soon!
      </p>
      <p class="time-text" *ngIf="resumeTime">
        Expected to resume at: <strong>{{ resumeTime }}</strong>
      </p>
    </div>
  </div>
